import { createSlice } from '@reduxjs/toolkit';
import { UserSchema } from '../types/UserSchema';
import { fetchUserProfile } from '@entities/User/module/services/fetchUserProfile';

const initialState: UserSchema = {
  userProfileData: null,
  isLoadedUserProfileData: false,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(fetchUserProfile.pending, state => {
      state.isLoadedUserProfileData = false;
    });
    builder.addCase(fetchUserProfile.fulfilled, (state, action) => {
      if (action.payload) {
        state.userProfileData = action.payload;
      }
      state.isLoadedUserProfileData = true;
    });
    builder.addCase(fetchUserProfile.rejected, state => {
      state.isLoadedUserProfileData = true;
    });
  },
});

export const { actions: userActions } = userSlice;
